if (!customElements.get('ae-fortress')) {
  customElements.define('ae-fortress', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-fortress-interest]');
        if (!trigger) return;
        const select = this.querySelector('#FortressInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.fortressInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}

